import { render, staticRenderFns } from "./SeatsTable.vue?vue&type=template&id=5729115e&"
import script from "./SeatsTable.vue?vue&type=script&lang=js&"
export * from "./SeatsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports